import React from 'react'
import classes from './Returnmessage.module.scss';
export default function Returnmessage(props) {
  return (
    <div className={`${classes.return_container} ${props.type==='error' ? classes.content_error : classes.content_success}`}>
        <span className={classes.message}>{props.message}</span>
    </div>
  )
} 
 